import type { Interest, UpdateInterestPayload } from '../entities/interest.entity'
import type { InterestRepository } from '../repositories/interest_repository'

export class UpdateInterestUseCase {
  constructor(private readonly repository: InterestRepository) {}

  execute(payload: UpdateInterestPayload): Promise<Interest> {
    return this.repository.update(payload)
  }
}
